import { ApiFetch } from '../../../shared/utils/fetch'

export type Solution = {
  id: string
  slug: string
  name: string
  description: string | null
  isActive: boolean
  createdAt: string
  updatedAt: string
}

export type Industry = {
  id: string
  name: string
  isActive: boolean
  createdAt: string
  updatedAt: string
}

export type BusinessCategory = {
  id: string
  name: string
  isActive: boolean
  createdAt: string
  updatedAt: string
}

export const metadataApi = {
  // ── Solutions ─────────────────────────────────────────────────────────────
  listSolutions: (): Promise<Solution[]> => ApiFetch.get('/solutions'),
  createSolution: (data: { slug: string; name: string; description?: string }): Promise<Solution> =>
    ApiFetch.post('/solutions', data),
  updateSolution: (slug: string, data: Partial<{ name: string; description: string }>): Promise<Solution> =>
    ApiFetch.put(`/solutions/${slug}`, data),
  deactivateSolution: (slug: string): Promise<Solution> =>
    ApiFetch.post(`/solutions/${slug}/deactivate`),

  // ── Industries ────────────────────────────────────────────────────────────
  listIndustries: (): Promise<Industry[]> => ApiFetch.get('/industries'),
  createIndustry: (data: { name: string }): Promise<Industry> =>
    ApiFetch.post('/industries', data),
  updateIndustry: (id: string, data: { name: string }): Promise<Industry> =>
    ApiFetch.put(`/industries/${id}`, data),
  deactivateIndustry: (id: string): Promise<Industry> =>
    ApiFetch.del(`/industries/${id}`),

  // ── Business Categories ───────────────────────────────────────────────────
  listBusinessCategories: (): Promise<BusinessCategory[]> => ApiFetch.get('/business-categories'),
  createBusinessCategory: (data: { name: string }): Promise<BusinessCategory> =>
    ApiFetch.post('/business-categories', data),
  updateBusinessCategory: (id: string, data: { name: string }): Promise<BusinessCategory> =>
    ApiFetch.put(`/business-categories/${id}`, data),
  deactivateBusinessCategory: (id: string): Promise<BusinessCategory> =>
    ApiFetch.del(`/business-categories/${id}`),
}
